import React, { useEffect, useState } from "react";
import WpDynamicTable from "../../Components/WhatsappTable/WpDynamicTable";
import { useDispatch, useSelector } from "react-redux";
import {
  AddProject,
  DeleteProject,
  fetchProjects,
  UpdateProject,
} from "../../Redux/WhatsappSlice/Project";
import { toast } from "react-toastify";
import Loader from "../../Components/Loader/Loader";

const Project = () => {
  const dispatch = useDispatch();

  const { ProjectData } = useSelector((state) => state.Project);

  useEffect(() => {
    dispatch(fetchProjects());
  }, [dispatch]);

  const [formData, setFormData] = useState({
    project_name: "",
  });

  const [errors, setErrors] = useState({});
  const [isEditMode, setIsEditMode] = useState(false);

  const [editingId, setEditingId] = useState(null);

  // Form validation
  const validate = () => {
    const newErrors = {};

    if (!formData.project_name.trim()) {
      newErrors.project_name = "Project Name is required";
    }

    return newErrors;
  };

  const handleEdit = (row) => {
    setIsEditMode(true);
    setEditingId(row.MainId);

    setFormData({
      project_name: row.project_name,
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleDelete = async (row) => {
    const isConfirmed = window.confirm(
      `Are you sure you want to delete this Project?`
    );
    if (!isConfirmed) return;

    try {
      await dispatch(DeleteProject({ id: row.MainId })).unwrap();
      toast.success("Project deleted successfully!", {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
      });
      dispatch(fetchProjects()); // refresh list
    } catch (error) {
      toast.error(`Failed to delete Project: ${error}`, {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      try {
        if (isEditMode) {
          await dispatch(
            UpdateProject({ id: editingId, values: formData })
          ).unwrap();
          toast.success("Project updated successfully!");
        } else {
          await dispatch(AddProject({ values: formData })).unwrap();
          toast.success("Project added successfully!");
        }

        setFormData({ project_name: "" });
        setIsEditMode(false);
        setEditingId(null);
        dispatch(fetchProjects());
      } catch (error) {
        toast.error(`Failed to ${isEditMode ? "update" : "add"} Project`);
      }
    } else {
      toast.error("Please fix validation errors.");
    }
  };

  const columns = [
    { field: "id", headerName: "No", flex: 1 },
    { field: "project_name", headerName: "Project Name", flex: 1 },
    {
      field: "actions",
      headerName: "Actions",
      flex: 1,
      renderCell: (params) => (
        <div className="flex space-x-2 justify-center gap-4">
          <button
            className="bg-blue-500 text-white px-3 py-2 rounded hover:bg-blue-600"
            onClick={() => handleEdit(params.row)}
          >
            Update
          </button>
          <button
            className="bg-red-500 text-white px-3 py-2 rounded hover:bg-red-600"
            onClick={() => handleDelete(params.row)}
          >
            Delete
          </button>
        </div>
      ),
    },
  ];

  const rows =
    ProjectData?.map((el, index) => ({
      id: index + 1,
      MainId: el._id,
      project_name: el?.project_name,
    })) || [];

  if (!ProjectData ) {
    return <Loader />;
  }

  return (
    <>
      <div className="">
        <div className="title">
          <h3 className="text-xl font-bold main_title_page text-white px-4 py-2 inline-block rounded">
            {isEditMode ? "Update Project" : "Add Project"}
          </h3>
        </div>

        <div className="Form_bg_color bg-white shadow-sm rounded-xl mt-4">
          <form onSubmit={handleSubmit} className="grid grid-cols-12 gap-4 p-4">
            {/* Slab Name Input */}
            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="my-2 font-semibold">Project Name</h5>
              <input
                type="text"
                name="project_name"
                placeholder="Enter Project Name"
                value={formData.project_name}
                onChange={handleChange}
                className="bg-[#F3F8FB] w-full p-2 border-2 border-black rounded"
              />
              {errors.project_name && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.project_name}
                </p>
              )}
            </div>

            {/* Submit Button */}
            <div className="submit_Form col-span-12 lg:col-span-4 md:col-span-6 flex md:mt-10 items-center gap-2">
              <button type="submit" className="All_button">
                {isEditMode ? "Update" : "Submit"}
              </button>
              {isEditMode && (
                <button
                  type="button"
                  onClick={() => {
                    setIsEditMode(false);
                    setEditingId(null);
                    setFormData({ project_name: "" });
                  }}
                  className="All_button bg-gray-500 hover:bg-gray-600"
                >
                  Cancel
                </button>
              )}
            </div>
          </form>
        </div>

        <div className="px-2 py-6">
          <div className="title">
            <h3 className="text-xl font-bold main_title_page text-white px-4 py-2 inline-block rounded">
              View Project
            </h3>
          </div>
          <div className="rounded-lg overflow-x-auto mt-5">
            <WpDynamicTable columns={columns} rows={rows} />
          </div>
        </div>
      </div>
    </>
  );
};

export default Project;
